import styled from 'styled-components';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ErrorMessage = styled.p`
  font-size: 1.8rem;
  padding: 0.3rem 0;
  margin-bottom: 2rem;
`;
